<template>
  <Dialog
    :open="modelValue"
    as="div"
    class="relative z-50"
    @close="emit('update:modelValue', false)"
  >
    <div
      class="fixed inset-0 bg-black/30"
      aria-hidden="true"
    />
    <div class="flex fixed inset-0 justify-center items-center px-2 md:px-0">
      <DialogPanel class="flex overflow-y-auto flex-col py-2 px-3 w-full max-w-md bg-gray-50 rounded md:p-4">
        <button
          class="mb-2 ml-auto focus:outline-none"
          @click="emit('update:modelValue', false)"
        >
          <XMarkIcon class="w-5 h-5 fill-gray-700 md:w-6 md:h-6" />
        </button>
        <DialogTitle class="mb-3 font-serif text-xl text-center text-gray-700 md:text-2xl">
          Estados de una orden
        </DialogTitle>
        <DialogDescription class="mb-2 text-sm font-light text-gray-700 md:text-base">
          A continuación explicamos en detalle que significa cada estado.
        </DialogDescription>
        <div class="mb-5 text-sm font-light md:text-base">
          <p>
            <span class="font-semibold">Pendiente:</span>
            <span>
              Hemos recibido la orden pero aún no ha sido aprobada. Si es tu primera orden te llamaremos
              para coordinar un cupo de crédito antes de aprobar la orden.
            </span>
          </p>
          <p>
            <span class="font-semibold">Aprobada:</span>
            <span>
              La orden ha sido aprobada y las marcas están preparando el pedido. En algunas ocaciones el pedido
              puede ser modificado por las marcas por falta de stock o alguna otra razón.
            </span>
          </p>
          <p>
            <span class="font-semibold">En despacho:</span>
            <span>
              Alguno de las marcas que pediste ya está en camino a tu tienda.
            </span>
          </p>
          <p>
            <span class="font-semibold">Entregado:</span>
            <span>
              Todos los productos de la orden han sido entregados en tu tienda.
            </span>
          </p>
        </div>
        <button
          class="self-center p-1 w-full text-sm text-white bg-lk-green hover:bg-lk-green-deep rounded-md md:text-base"
          @click="emit('update:modelValue', false)"
        >
          Aceptar
        </button>
      </DialogPanel>
    </div>
  </dialog>
</template>
<script lang="ts" setup>
import { XMarkIcon } from '@heroicons/vue/24/solid';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
} from '@headlessui/vue';

interface LokalMessageDialogProps {
  modelValue: boolean
}
withDefaults(defineProps<LokalMessageDialogProps>(), {
  modelValue: false,
});

const emit = defineEmits<{(e: 'accept-message'): void,
  (e: 'update:modelValue', value: boolean): void
}>();
</script>
